import React from 'react';

const Notifications = () => {
  return (
    <div className="container">
    <div className="row">
    <div className="card">
      <div className="card-header">
        <h4 className="card-header-title">
          Notifications
        </h4>
        <button className="btn btn-sm btn-white">
          Disable all
        </button>
      </div>
      <div className="table-responsive">
        <table className="table table-sm table-nowrap card-table">
          <thead>
            <tr>
              <th>Type</th>
              <th className="text-center">Call</th>
              <th className="text-center">Email</th>
              <th className="text-center">SMS</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Direct messages</td>
              <td className="text-center"></td>
              <td className="text-center">
                <input type="checkbox" id="emailCheckboxOne" checked />
              </td>
              <td className="text-center">
                <input type="checkbox" id="smsCheckboxOne" checked />
              </td>
            </tr>
            <tr>
              <td>Reminders</td>
              <td className="text-center"></td>
              <td className="text-center">
                <input type="checkbox" id="emailCheckboxTwo" checked />
              </td>
              <td className="text-center">
                <input type="checkbox" id="smsCheckboxTwo" checked />
              </td>
            </tr>
            <tr>
              <td>API Limits</td>
              <td className="text-center">
                <input type="checkbox" id="callCheckboxThree" />
              </td>
              <td className="text-center">
                <input type="checkbox" id="emailCheckboxThree" checked />
              </td>
              <td className="text-center">
                <input type="checkbox" id="smsCheckboxThree" checked />
              </td>
            </tr>
            <tr>
              <td>Policy &amp; Community</td>
              <td className="text-center">
                <input type="checkbox" id="callCheckboxFour" />
              </td>
              <td className="text-center">
                <input type="checkbox" id="emailCheckboxFour" checked />
              </td>
              <td className="text-center">
                <input type="checkbox" id="smsCheckboxFour" checked />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div className="card">
    <div className="card-header">
      <h4 className="card-header-title">
        Subscriptions
      </h4>
      <button className="btn btn-sm btn-white">
        Unsubscribe all
      </button>
    </div>
    <div className="card-body">
      <div className="list-group list-group-flush my-n3">
        <div className="list-group-item">
          <div className="row align-items-center">
            <div className="col">
              <h4 className="font-weight-base mb-1">Sales &amp; Promotions</h4>
              <small className="text-body-secondary">
                We only notify you for significant promotions
              </small>
            </div>
            <div className="col-auto">
              <div className="form-check form-switch">
                <input className="form-check-input" id="subscriptionsSwitchOne" type="checkbox" checked />
                <label className="form-check-label" htmlFor="subscriptionsSwitchOne"></label>
              </div>
            </div>
          </div>
        </div>
        <div className="list-group-item">
          <div className="row align-items-center">
            <div className="col">
              <h4 className="font-weight-base mb-1">Product updates</h4>
              <small className="text-body-secondary">
                Major changes in our product offering
              </small>
            </div>
            <div className="col-auto">
              <div className="form-check form-switch">
                <input className="form-check-input" id="subscriptionsSwitchTwo" type="checkbox" checked />
                <label className="form-check-label" htmlFor="subscriptionsSwitchTwo"></label>
              </div>
            </div>
          </div>
        </div>
        <div className="list-group-item">
          <div className="row align-items-center">
            <div className="col">
              <h4 className="font-weight-base mb-1">Newsletter</h4>
              <small className="text-body-secondary">
                Updates on what’s going on here at Landkit.
              </small>
            </div>
            <div className="col-auto">
              <div className="form-check form-switch">
                <input className="form-check-input" id="subscriptionsSwitchThree" type="checkbox" checked />
                <label className="form-check-label" htmlFor="subscriptionsSwitchThree"></label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
  </div>
  );
};

export default Notifications;
